export function dispatchCustomEvent(t,e,o,n={}){const s=`${t.nodeName.toLocaleLowerCase()}:${e}`;t.dispatchEvent(new CustomEvent(s,{detail:o,bubbles:!0,composed:!0,...n}))}
//# sourceMappingURL=events.js.map